(function() {
  'use strict';

  angular
    .module('ykwx', [
    	// Generated modules
    	'ngCookies', 
    	'ngSanitize', 
    	'ngResource', 
    	'ngRoute', 
        'ngCachedResource',
        'ui.router',
        'ngMaterial',
        // Pagination
        'infinite-scroll',
        // Smooth scroll
        'duScroll',
        // Addthis for angular
        'sn.addthis',
        // Loading bar
        'angular-loading-bar',
        'angular-storage',
        'truncate',
        'angular.filter',
        // Page titles & Meta data
        'viewhead',
        'ng-showdown',
        'contentful',
        'slickCarousel',
        'angular-google-analytics'
    ]);

})();

angular.module('ykwx')

	.controller('StaticPagesHomeController', function($scope, $rootScope, $stateParams, contentful, $filter, $timeout) {

		$scope.page = 'home';

		$scope.loading = true;
		$scope.loadIn = false;

      	// Fetch entries from API
    	contentful
      		.entries('content_type=homePage&limit=1')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[0].fields;

		          	$timeout(function (){
		          		$scope.loadIn = true;
		          	}, 1000);


		  			contentful
			      		.entries('content_type=artist')
			      		.then(
					        // Success handler
					        function(response){
					          	$scope.allArtists = response.data.items;
					          	$scope.loading = false;
					          	angular.forEach($scope.entry.releases, function(a, i){
					          		angular.forEach($scope.allArtists, function(e){
					          			if (e.sys.id == a.fields.artistName.sys.id) {
					          				$scope.entry.releases[i].artistName = e.fields.artistName;
					          			}
					          		});
					          	});
					        }
				      	);
		        }
	      	);


		// Meta data
		$rootScope.pageTitle = "Welcome";
		$rootScope.pageDescription = "Keep it in motion keep it in line. Gothenburg based record label.";
		$rootScope.pageUrl = "/";
		$rootScope.pageImage = "https://ykwx-assets.s3.amazonaws.com/woah-dad/woah-dad-bg.jpg";

	})

	.controller('StaticPagesAboutController', function($scope, $rootScope, $stateParams, contentful) {

		$scope.page = 'about';
		$scope.entryId = '2qKZ4CctNO4A0SkKgK20uw';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
      		.entry($scope.entryId)
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.fields;
		          	$scope.loading = false;
		        }
	      	);

		// Meta data
		$rootScope.pageTitle = "About";
		$rootScope.pageDescription = "Keep it in motion keep it in line. Gothenburg based record label.";
		$rootScope.pageUrl = "about";
		$rootScope.pageImage = "https://ykwx-assets.s3.amazonaws.com/woah-dad/woah-dad-bg.jpg";

	})

	.controller('StaticPagesContactController', function($scope, $rootScope, $stateParams, contentful) {

		$scope.page = 'contact';
		$scope.entryId = '3NVa515Ny0kQMiIOu0AYYi';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
      		.entry($scope.entryId)
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.fields;
		          	$scope.loading = false;
		        }
	      	);

		// Meta data
		$rootScope.pageTitle = "Contact";
		$rootScope.pageDescription = "Keep it in motion keep it in line. Gothenburg based record label.";
		$rootScope.pageUrl = "contact";
		$rootScope.pageImage = "https://ykwx-assets.s3.amazonaws.com/woah-dad/woah-dad-bg.jpg";

	})


	.controller('StaticPagesAgencyController', function($scope, $rootScope, $stateParams, contentful, $timeout) {

		$scope.page = 'agency';
		// $scope.entryId = 'xOdwEkM0lEkUyqAAsg8oM';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
    		.entries('content_type=agencyPage&limit=1')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[0].fields;
		          	$timeout(function () {
					    $scope.loading = false;
					}, 1000);

		        }
	      	);


		// Meta data
		$rootScope.pageTitle = "Agency";
		$rootScope.pageDescription = "Keep it in motion keep it in line. Gothenburg based record label.";
		$rootScope.pageUrl = "agency";
		$rootScope.pageImage = "https://ykwx-assets.s3.amazonaws.com/woah-dad/woah-dad-bg.jpg";

	})


	.controller('StaticPagesLiveController', function($scope, $rootScope, $stateParams, contentful, $location, $filter) {

		$scope.page = 'live';
		$scope.loading = true;

		$scope.entries = [];
		$scope.fetchedItems = 0;
		$scope.totalItems = 0;

		$scope.limit = 16;
		$scope.skip = 0;
		$scope.ready = false;

		$scope.search = {
			q:''
		};
		$scope.cityId = '';
		$scope.filtersOn = false;



		$scope.addFilters = function(id, name, type) {
			$scope.cityId = id;
			$scope.cityName = name;
			$location.search('location', $scope.cityName);
			$scope.search = {
				q:''
			};
			$scope.filtersOn = true;
			$scope.entries = [];
			$scope.fetchedItems = 0;
			$scope.totalItems = 0;
			$scope.skip = 0;
			$scope.addMoreItems();
		};

		$scope.searchLive = function() {
			$location.search('search', $scope.search.q);
			$scope.filtersOn = true;
			$scope.loading = true;
			$scope.entries = [];
			$scope.fetchedItems = 0;
			$scope.totalItems = 0;
			$scope.skip = 0;
			$scope.addMoreItems();
		};


		$scope.clearFilters = function() {
			$scope.filtersOn = false;
			$scope.cityId = '';
			$scope.cityName = '';
			$scope.search = {
				q:''
			};
			$location.url($location.path());
			$scope.entries = [];
			$scope.fetchedItems = 0;
			$scope.totalItems = 0;
			$scope.skip = 0;
			$scope.addMoreItems();
		};

		var today = new Date();
		$scope.today = $filter('date')(today, 'yyyy-MM-dd');
		// $scope.today = '2018-10-01'

		// Fetch entries from API
		$scope.addMoreItems = function() {

			// Reset scroll
			$scope.ready = false;

			if ( $scope.totalItems >= $scope.fetchedItems ) {
				contentful
					.entries('content_type=shows&order=fields.date&fields.city=' + $scope.cityId + '&fields.date[gte]=' + $scope.today + '&fields.title[match]=' + $scope.search.q + '&limit=' + $scope.limit + '&skip=' + $scope.skip)

		      		.then(
				        // Success handler
				        function(response){

							angular.forEach(response.data.items, function (e) {
								$scope.entries.push(e);
							});

							$scope.entries = $filter('orderBy')($scope.entries, 'fields.date', false);

		                    $scope.skip = $scope.skip + $scope.limit;
		                    $scope.totalItems = response.data.total;
		                    $scope.fetchedItems = $scope.entries.length;

							console.log('total', $scope.totalItems);
							console.log('fetched', $scope.fetchedItems);

		                    // Fire scroll
		                    $scope.ready = true;
							$scope.loading = false;
				        }
			      	);

			};
		};



		$scope.fetchCities = function() {
			contentful
				.entries('content_type=shows')
				.then(
					// Success handler
					function(response){
						$scope.cities = [];
						angular.forEach(response.data.items, function(e) {
							if($scope.cities.indexOf(e.fields.city) === -1) {
								$scope.cities.push(e.fields.city);
							}
						});
					}
				);
		};

		$scope.fetchCities();


		// Meta data
		$rootScope.pageTitle = "Live";
		$rootScope.pageDescription = "Keep it in motion keep it in line. Gothenburg based record label.";
		$rootScope.pageUrl = "live";
		$rootScope.pageImage = "https://ykwx-assets.s3.amazonaws.com/woah-dad/woah-dad-bg.jpg";

	})


	;

angular.module('ykwx')
  	
	.controller('ShopIndexController', function($document, $scope, $rootScope, $stateParams, contentful, $filter) {

		$scope.loading = true;
		$scope.page = 'shop';
		
		$scope.entries = [];
        $scope.fetchedItems = 0;
        $scope.totalItems = 0;

        $scope.limit = 9;
        $scope.skip = 0;
        $scope.ready = false;

		contentful
	      	.entries('content_type=shopPage&limit=1')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.header = response.data.items[0].fields;
		          	console.log($scope.header);
					$scope.loading = false;
		        }
	      	);


		// Fetch entries from API
		$scope.addMoreItems = function() {

            // Reset scroll
            $scope.ready = false;          

            if ( $scope.totalItems >= $scope.fetchedItems ) {
		    	contentful
		      		.entries('content_type=merchandise&limit=' + $scope.limit + '&skip=' + $scope.skip)
		      		.then(
				        // Success handler
				        function(response){

				          	angular.forEach(response.data.items, function (e) {
		                        $scope.entries.push(e);
		                    });

		                    $scope.skip = $scope.skip + $scope.limit;
		                    $scope.totalItems = response.data.total;
		                    $scope.fetchedItems = $scope.entries.length;

		                    // Fire scroll
		                    $scope.ready = true;
							$scope.loading = false;
				        }
			      	);

			};
		};


		// Meta data
		$rootScope.pageTitle = "Shop";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "shop";
		$rootScope.pageImage = "";

	})


	.controller('ShopShowController', function($scope, $rootScope, $stateParams, contentful) {

		$scope.loading = true;
		$scope.loadingExtra = true;
		$rootScope.title = 'Shop';
		$scope.page = 'shop_show';
		
		// Fetch entries from API
    	contentful
      		.entries('content_type=merchandise&fields.slug=' + $stateParams.slug)
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[0].fields;
		          	
		          	$scope.loading = false;

		          	// Meta data
					$rootScope.pageTitle = $scope.entry.title;
					$rootScope.pageDescription = $scope.entry.excerpt;
					$rootScope.pageUrl = "shop/" + $scope.entry.slug;
					$rootScope.pageImage = "https:" + $scope.featuredImage;

		        }
	      	);


      	


	});

angular.module('ykwx')
  	
	.controller('ReleasesIndexController', function($document, $scope, $rootScope, $stateParams, contentful, $filter) {

		$scope.loading = true;
		$scope.page = 'releases';
		
		$scope.entries = [];
        $scope.fetchedItems = 0;
        $scope.totalItems = 0;

        $scope.limit = 9;
        $scope.skip = 0;
        $scope.ready = false;


		// Fetch entries from API
		$scope.addMoreItems = function() {

            // Reset scroll
            $scope.ready = false;          

            if ( $scope.totalItems >= $scope.fetchedItems ) {
		    	contentful
		      		.entries('content_type=release&limit=' + $scope.limit + '&skip=' + $scope.skip)
		      		.then(
				        // Success handler
				        function(response){

				          	angular.forEach(response.data.items, function (e) {
		                        $scope.entries.push(e);
		                    });

		                    $scope.skip = $scope.skip + $scope.limit;
		                    $scope.totalItems = response.data.total;
		                    $scope.fetchedItems = $scope.entries.length;

		                    // Fire scroll
		                    $scope.ready = true;
							$scope.loading = false;
				        }
			      	);

			};
		};


		// Meta data
		$rootScope.pageTitle = "Releases";
		$rootScope.pageDescription = "Keep it in motion keep it in line. Gothenburg based record label.";
		$rootScope.pageUrl = "releases";
		$rootScope.pageImage = "https://ykwx-assets.s3.amazonaws.com/woah-dad/woah-dad-bg.jpg";

	})


	.controller('ReleasesShowController', function($scope, $rootScope, $stateParams, contentful, $timeout) {

		$scope.loading = true;
		$scope.loadingExtra = true;
		$rootScope.title = 'Releases';
		$scope.page = 'releases_show';
		
		// Fetch entries from API
    	contentful
      		.entries('content_type=release&fields.slug=' + $stateParams.slug)
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[0].fields;
		          	
		          	$timeout(function () {
					    $scope.loading = false;
					}, 1000);

		          	// Meta data
					$rootScope.pageTitle = $scope.entry.title;
					$rootScope.pageDescription = $scope.entry.excerpt;
					$rootScope.pageUrl = "releases/" + $scope.entry.slug;
					$rootScope.pageImage = "https:" + $scope.featuredImage;

		        }
	      	);


      	


	});

angular.module('ykwx')
  	
	.controller('NewsIndexController', function($document, $scope, $rootScope, $stateParams, contentful, $filter) {

		$scope.loading = true;
		$scope.page = 'news';
		
		$scope.entries = [];
        $scope.fetchedItems = 0;
        $scope.totalItems = 0;

        $scope.limit = 16;
        $scope.skip = 0;
        $scope.ready = false;


		// Fetch entries from API
		$scope.addMoreItems = function() {

            // Reset scroll
            $scope.ready = false;          

            if ( $scope.totalItems >= $scope.fetchedItems ) {
		    	contentful
		      		.entries('content_type=news&order=-fields.date&limit=' + $scope.limit + '&skip=' + $scope.skip)
		      		.then(
				        // Success handler
				        function(response){

				          	angular.forEach(response.data.items, function (e) {
		                        $scope.entries.push(e);
		                    });

		                    $scope.skip = $scope.skip + $scope.limit;
		                    $scope.totalItems = response.data.total;
		                    $scope.fetchedItems = $scope.entries.length;

		                    // Fire scroll
		                    $scope.ready = true;
							$scope.loading = false;
				        }
			      	);

			};
		};


		// Meta data
		$rootScope.pageTitle = "News";
		$rootScope.pageDescription = "Keep it in motion keep it in line. Gothenburg based record label.";
		$rootScope.pageUrl = "news";
		$rootScope.pageImage = "https://ykwx-assets.s3.amazonaws.com/woah-dad/woah-dad-bg.jpg";

	})


	.controller('NewsShowController', function($scope, $rootScope, $stateParams, contentful, $timeout) {

		$scope.loading = true;
		$scope.loadingExtra = true;
		$rootScope.title = 'News';
		$scope.page = 'news_show';
		
		// Fetch entries from API
    	contentful
      		.entries('content_type=news&fields.slug=' + $stateParams.slug)
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[0].fields;
		          	console.log($scope.entry);	
		          	          	
				    contentful
		          		.entries('content_type=news&order=-sys.createdAt')
				    	.then(
					        // Success handler
					        function(response){
					          	$scope.all_entries = response.data.items;
					          	angular.forEach($scope.all_entries, function (e, i) {
					          		if (e.fields.slug == $stateParams.slug) {
					          			$scope.index = i + 1;
					          		}
					          		if (i == $scope.index) {
					          			$scope.next_article = e.fields.slug;
					          		}
					          	});
					          	$timeout(function () {
								    $scope.loading = false;
								}, 1000);
								
					        }
				      	);
					

		          	// Meta data
					$rootScope.pageTitle = $scope.entry.title;
					$rootScope.pageSlug = $scope.entry.slug;
					$rootScope.pageDescription = $scope.entry.excerpt;
					$rootScope.pageUrl = "news/" + $scope.entry.slug;
					$rootScope.pageImage = "https:" + $scope.featuredImage;

		        }
	      	);


        $scope.getYoutube = function (videoId) {
            var id = videoId.split("=")[1];
            return 'https://www.youtube.com/embed/' + id;
        };
      	


	});

angular.module('ykwx')
  	
	.controller('ArtistsIndexController', function($document, $scope, $rootScope, $stateParams, contentful, $filter) {

		$scope.loading = true;
		$scope.page = 'artists';
		
		$scope.entries = [];
        $scope.fetchedItems = 0;
        $scope.totalItems = 0;

        $scope.limit = 90;
        $scope.skip = 0;
        $scope.ready = false;


		// Fetch entries from API
		$scope.addMoreItems = function() {

            // Reset scroll
            $scope.ready = false;          

            if ( $scope.totalItems >= $scope.fetchedItems ) {
		    	contentful
		      		.entries('content_type=artist&limit=' + $scope.limit + '&skip=' + $scope.skip)
		      		.then(
				        // Success handler
				        function(response){

				          	angular.forEach(response.data.items, function (e) {
		                        $scope.entries.push(e);
		                    });

		                    $scope.skip = $scope.skip + $scope.limit;
		                    $scope.totalItems = response.data.total;
		                    $scope.fetchedItems = $scope.entries.length;

		                    // Fire scroll
		                    $scope.ready = true;
							$scope.loading = false;
				        }
			      	);

			};
		};


		// Meta data
		$rootScope.pageTitle = "Artists";
		$rootScope.pageDescription = "Keep it in motion keep it in line. Gothenburg based record label.";
		$rootScope.pageUrl = "artists";
		$rootScope.pageImage = "https://ykwx-assets.s3.amazonaws.com/woah-dad/woah-dad-bg.jpg";

	})


	.controller('ArtistsShowController', function($scope, $rootScope, $stateParams, contentful, $timeout) {

		$scope.loading = true;
		$scope.loadingExtra = true;
		$rootScope.title = 'Artists';
		$scope.page = 'artists_show';
		
		// Fetch entries from API
    	contentful
      		.entries('content_type=artist&fields.slug=' + $stateParams.slug)
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.items[0].fields;
		          	console.log(response.data.items[0]);
		          	if (!$scope.entry.liveShows) {
		          		$scope.entry.liveShows = [];
		          	}
		      		contentful
		      			.entries('content_type=shows&fields.artist.sys.id=' + response.data.items[0].sys.id)
		      			.then(
				        	// Success handler
				        	function(response){
								$scope.entry.liveShows.push(response.data.items[0]);
				        	}
			      		);
		          	
		          	$timeout(function () {
					    $scope.loading = false;
					}, 1000);

		          	// Meta data
					$rootScope.pageTitle = $scope.entry.artistName;
					$rootScope.pageDescription = $scope.entry.biography;
					$rootScope.pageUrl = "artists/" + $scope.entry.slug;
					$rootScope.pageImage = "https:" + $scope.featuredImage;

		        }
	      	);





	});

angular.module('ykwx')
  	
	.controller('AppController', function($scope, $rootScope, $document, $window, $filter, $timeout, $location, $stateParams, $state, $mdSidenav, $mdDialog) {
		
		// Current datetime
		$scope.currentDate = new Date();

		// Scroll to top of page when hitting up arrow
		$scope.topScroll = function(e) {
			$document.scrollTopAnimated(0, 1000);
		};

	    // Scroll to top on page load
		$scope.$on('$viewContentLoaded', function(){
			$document.scrollTopAnimated(0, 100);
		});


	    $scope.openMenu = function($mdOpenMenu, ev) {
	    	originatorEv = ev;
	   		$mdOpenMenu(ev);
	    };
		
	    $scope.closeMenu = function($mdCloseMenu, ev) {
	    	originatorEv = ev;
	   		$mdCloseMenu(ev);
	    };

	    // Navigation side menu
	    $scope.toggleLeft = buildToggler('left');
		
		function buildToggler(navID) {
			return function() {
				$mdSidenav(navID)
					.toggle()
					.then(function () {
				});
			}
		}

		$scope.close = function () {
			$mdSidenav('left').close();
		};


		$scope.showNewsletter = function($event, s) {
			$mdDialog.show({
				clickOutsideToClose: true,
				templateUrl: 'templates/views/shared/newsletter-signup.html',
				scope: $scope,
				preserveScope: true,
				targetEvent: $event
			});
		};

		$scope.closeModal = function() {
			$mdDialog.hide();
		};


	});
(function() {
  'use strict';

  angular
    .module('ykwx');
    
})();

(function() {
  'use strict';

  angular
    .module('ykwx')

    // The CMS API
    // .factory('Api', function($cachedResource, Endpoint) {
    //     return function(key) {
    //         key = key.join? key.join('/'):key;
    //         return $cachedResource(key, Endpoint + key + '/:id.json', {id: "@id"}, {
    //             'update': {method: 'PUT'}
    //         });
    //     };
    // })

    // Trusted hosts [ie, a url from youtube, vimeo hosted files etc]
    .filter('trustUrl', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    })

    // Trust embed
    .filter('trustEmbed', function ($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    })

    // Capitalise text
    .filter('capitalize', function() {
        return function(input, all) {
            return (!!input) ? input.replace(/([^\W_]+[^\s-]*) */g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}) : '';
        };
    })

    // Replace hyphens with space
    .filter('space', function() {
        return function(str) {
            return str.replace(/-/g, ' ');
        };
    })

    .filter('sanitize', function() {
        return function(str) {
            return str.replace(/\s+/g, '-');
        };
    })

    .filter('removeSpaces', function() {
        return function(string) {
            if (!angular.isString(string)) {
                return string;
            }
            return string.replace(/[\s]/g, '');
        };
    })

    // Chop text string if longer than defined length
    .filter('strLimit', ['$filter', function($filter) {
        return function(input, limit) {
            if (! input) return;
            if (input.length <= limit) {
                return input;
            }
            return $filter('limitTo')(input, limit) + '...';
        };

    }])

    .filter('categoryType', function($rootScope, $filter) {
        return function(str) {
            angular.forEach($rootScope.category_types, function(e){
                if(e.sys.id == str) {
                    return e.fields.title;
                }
            });
        };
    })


    ;

})();

(function () {
  "use strict";

  angular
    .module("ykwx")
    .config(routeConfig)

    .config(function (
      $sceDelegateProvider,
      contentfulProvider,
      AnalyticsProvider
    ) {
      // Trust these urls
      $sceDelegateProvider.resourceUrlWhitelist([
        "self",
        "*://www.youtube.com/**",
        "*://www.vimeo.com/**",
        "*://www.shopify.com/**",
        "*://www.mixcloud.com/**",
        "*://*.contentful.com/**",
      ]);

      // Contentful API
      contentfulProvider.setOptions({
        space: "jik4pk4xcyvw",
        accessToken:
          "b5b94a943864e783b7376a8772f4f41c6a2335038a104de7dee42d54a767caaf",
      });

      // Google analytics
      AnalyticsProvider.setAccount("UA-115109856-1");
    })

    .run(function (Analytics) {});

  function routeConfig($stateProvider, $locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise("/");

    // Routes for the site
    $stateProvider

      .state("home", {
        url: "/",
        templateUrl: "templates/views/static_pages/home.html",
        controller: "StaticPagesHomeController",
      })

      .state("about", {
        url: "/about",
        templateUrl: "templates/views/static_pages/about.html",
        controller: "StaticPagesAboutController",
      })

      .state("contact", {
        url: "/contact",
        templateUrl: "templates/views/static_pages/contact.html",
        controller: "StaticPagesContactController",
      })

      .state("agency", {
        url: "/agency",
        templateUrl: "templates/views/static_pages/agency.html",
        controller: "StaticPagesAgencyController",
      })

      .state("news_index", {
        url: "/news",
        templateUrl: "templates/views/news/index.html",
        controller: "NewsIndexController",
      })

      .state("news_show", {
        url: "/news/:slug",
        templateUrl: "templates/views/news/show.html",
        controller: "NewsShowController",
      })

      .state("artists_index", {
        url: "/artists",
        templateUrl: "templates/views/artists/index.html",
        controller: "ArtistsIndexController",
      })

      .state("artists_show", {
        url: "/artists/:slug",
        templateUrl: "templates/views/artists/show.html",
        controller: "ArtistsShowController",
      })

      .state("releases_index", {
        url: "/releases",
        templateUrl: "templates/views/releases/index.html",
        controller: "ReleasesIndexController",
      })

      .state("releases_show", {
        url: "/releases/:slug",
        templateUrl: "templates/views/releases/show.html",
        controller: "ReleasesShowController",
      });

    // .state('shop_index', {
    //   url: '/shop',
    //   templateUrl: 'templates/views/shop/index.html',
    //   controller: 'ShopIndexController'
    // })

    // .state('shop_show', {
    //   url: '/shop/:slug',
    //   templateUrl: 'templates/views/shop/show.html',
    //   controller: 'ShopShowController'
    // })
  }
})();

(function() {
  'use strict';

  angular
    .module('ykwx')

    .directive('mdHeader', function mdHeader() {
        var mdHeader = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/header.html'
        };
        return mdHeader;
    })

    .directive('mdNavigation', function mdNavigation() {
        var mdNavigation = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/navigation.html'
        };
        return mdNavigation;
    })

    .directive('mdFooter', function footer() {
        var footer = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/footer.html'
        };
        return footer;
    })

    .directive('loading', function loading() {
        var loading = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/loading.html'
        };
        return loading;
    })

    .directive('newsletterSignup', function newsletterSignup() {
        var newsletterSignup = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/newsletter-signup.html'
        };
        return newsletterSignup;
    })




    // Smooth transition between pages
    .directive('smoothLoad', function ($window, $rootScope, $timeout) {
        return function() {

            $timeout(function () {
                $('.fade').fadeIn('slow');
            }, 500);

        };
    })

    // Add target blank to all links in CMS rendered content
    .directive('linkAway', function ($timeout) {
        return function() {
            
            $timeout(function () {
                $('.contents a').attr('target', '_blank');
            }, 500);

        };
    })


    .directive('homeNav', function ($timeout) {
        return function() {
            
            $timeout(function () {
                $('#logo-alt-w').fadeIn('slow');
            }, 1500);

            $timeout(function () {
                $('#logo-alt-w').fadeOut('slow');
            }, 4000);
            
            $timeout(function () {
                $('#wd-select').fadeIn('slow');
            }, 5000);

        };
    })




})();






















angular.module("ykwx").run(["$templateCache", function($templateCache) {$templateCache.put("templates/views/artists/index.html","<md-header></md-header><div class=\"page\" id=\"artists-list\" ng-init=\"addMoreItems()\"><loading></loading><div class=\"wrapper tiny-wrapper\" ng-if=\"!loading\"><article class=\"center-text\" id=\"list-block\" ng-repeat=\"e in entries | orderBy: &#39;fields.slug&#39;\"><div class=\"block-text\"><h2><a ng-bind-html=\"::e.fields.artistName\" ng-href=\"/artists/{{::e.fields.slug}}\"></a></h2></div><div class=\"block-img\"><img ng-src=\"{{::e.fields.mainImage.fields.file.url}}\"></div></article><div class=\"clearfix\"></div><div class=\"empty\"><div class=\"spacer\"></div><div class=\"center-text\" ng-if=\"!entries.length\">We don\'t have any articles matching that tag right now</div></div></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/artists/show.html","<md-header></md-header><div class=\"page grey-bg\" id=\"artists-post\"><loading></loading><article class=\"wrapper mid-wrapper block\" link-away=\"\" ng-if=\"!loading\"><div class=\"block-img center-text\"><img alt=\"{{::entry.mainImage.fields.file.title}}\" ng-src=\"{{::entry.mainImage.fields.file.url}}?w=720&amp;fm=jpg&amp;fl=progressive\"><h1 ng-bind-html=\"entry.artistName\"></h1></div><div class=\"block-text\"><div class=\"columns six\"><h2><i class=\"material-icons\">lens</i><span>Biography</span></h2><div class=\"contents\" markdown-to-html=\"::entry.biography\" ng-if=\"entry.biography\"></div></div><div class=\"columns six\"><div><h2><i class=\"material-icons\">lens</i><span>Links</span></h2><div class=\"contents\"><ul><li ng-if=\"entry.website\"><a ng-href=\"{{entry.website}}\" target=\"_blank\">Website</a></li><li ng-if=\"entry.spotify\"><a ng-href=\"{{entry.spotify}}\" target=\"_blank\">Spotify</a></li><li ng-if=\"entry.instagram\"><a ng-href=\"{{entry.instagram}}\" target=\"_blank\">Instagram</a></li><li ng-if=\"entry.facebook\"><a ng-href=\"{{entry.facebook}}\" target=\"_blank\">Facebook</a></li><li ng-if=\"entry.twitter\"><a ng-href=\"{{entry.twitter}}\" target=\"_blank\">Twitter</a></li></ul></div></div><div class=\"spacer\"></div><div><h2><i class=\"material-icons\">lens</i><span>Live</span></h2><div class=\"contents\"><ul ng-if=\"entry.liveShows\"><li ng-repeat=\"s in entry.liveShows | orderBy: fields.date\"><span>– {{s.fields.date | date: &#39;dd/MM/yy&#39;}} / {{s.fields.venue}} / {{s.fields.city}} /</span> <a class=\"bold\" ng-href=\"{{s.fields.ticketsLink}}\" target=\"_blank\">Tickets</a></li></ul><ul ng-if=\"!entry.liveShows.length\"><li>No upcoming shows for {{::entry.artistName}}</li></ul></div></div></div><div class=\"clearfix\"></div></div><div class=\"clearfix\"></div><hr class=\"coloured\"><div class=\"spacer\"></div><div id=\"artist-releases\"><div class=\"block-text\"><h2><i class=\"material-icons\">lens</i><span>Releases</span></h2></div><slick class=\"hide-on-mobile\" dots=\"false\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"3\"><div class=\"slick-slide\" ng-repeat=\"r in entry.releases\"><div class=\"block-img\"><a ng-href=\"/releases/{{::r.fields.slug}}\"><div class=\"image\" style=\"background-image:url({{::r.fields.mainImage.fields.file.url}}?w=320)\"></div></a></div><div class=\"block-text\"><h2><i class=\"material-icons\">lens</i><span ng-bind-html=\"::r.fields.artistName.fields.artistName\"></span></h2><h4>{{::r.fields.title}} / {{::r.fields.price}} Sek</h4></div></div></slick><article class=\"show-on-mobile\" ng-repeat=\"r in entry.releases\"><div class=\"block-img\"><a ng-href=\"/releases/{{::r.fields.slug}}\"><div class=\"image\" style=\"background-image:url({{::r.fields.mainImage.fields.file.url}}?w=320)\"></div></a></div><div class=\"block-text\"><h2><i class=\"material-icons\">lens</i><span ng-bind-html=\"::r.fields.artistName.fields.artistName\"></span></h2><h4>{{::r.fields.title}} / {{::r.fields.price}} Sek</h4></div></article><div class=\"center-text\" ng-if=\"!entry.releases.length\"><h4>Currently no releases for {{::entry.artistName}}</h4></div></div></article><div class=\"center-text\" id=\"load-more\"><h4><a class=\"link click\" ng-href=\"{{title | lowercase}}\"><i class=\"material-icons\">chevron_right</i><span>Back to {{title | lowercase}}</span></a></h4></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/news/index.html","<md-header></md-header><div class=\"page grey-bg\" id=\"news-list\" ng-init=\"addMoreItems()\"><loading></loading><div class=\"wrapper lrg-wrapper\" ng-if=\"!loading\"><section id=\"hero-section\"><article class=\"article-block block columns six\" ng-if=\"$index &lt; 2\" ng-repeat=\"e in entries | limitTo: 2\"><div class=\"block-img\"><a ng-href=\"/news/{{::e.fields.slug}}\"><div class=\"image\" ng-if=\"e.fields.images.length\" style=\"background-image:url({{::e.fields.images[0].fields.file.url}})\"></div><div class=\"image holding\" ng-if=\"!e.fields.images.length\"></div></a></div><div class=\"block-text\"><h2 class=\"blink\"><a ng-href=\"/news/{{::e.fields.slug}}\"><i class=\"material-icons\">lens</i><span ng-bind-html=\"::e.fields.title\"></span></a></h2><a class=\"underline-link\" ng-href=\"/news/{{::e.fields.slug}}\">Read more</a></div></article><div class=\"clearfix\"></div></section><section><article class=\"article-block block columns four\" ng-if=\"$index &gt; 1\" ng-repeat=\"e in entries\"><div class=\"block-img\"><a ng-href=\"/news/{{::e.fields.slug}}\"><div class=\"image\" ng-if=\"e.fields.images.length\" style=\"background-image:url({{::e.fields.images[0].fields.file.url}})\"></div><div class=\"image holding\" ng-if=\"!e.fields.images.length\"></div></a></div><div class=\"block-text\"><h2 class=\"blink\"><a ng-href=\"/news/{{::e.fields.slug}}\"><i class=\"material-icons\">lens</i><span ng-bind-html=\"::e.fields.title | words: 10\"></span></a></h2><a class=\"underline-link\" ng-href=\"/news/{{::e.fields.slug}}\">Read more</a></div></article><div class=\"clearfix\"></div><div class=\"empty\"><div class=\"spacer\"></div><div class=\"center-text\" ng-if=\"!entries.length\">There are no {{page}} articles</div></div></section></div><div class=\"center-text\" id=\"load-more\"><h4 class=\"link click\" ng-click=\"addMoreItems()\" ng-if=\"totalItems &gt; fetchedItems\"><i class=\"material-icons\">expand_more</i><span>Load more {{title | lowercase}} articles</span></h4><h4 class=\"link\" ng-if=\"totalItems == fetchedItems\"><span>No more {{title | lowercase}} articles</span></h4></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/news/show.html","<md-header></md-header><div class=\"page grey-bg\" id=\"news-post\"><loading></loading><article class=\"wrapper small-wrapper block\" link-away=\"\" ng-if=\"!loading\"><div class=\"block-img\"><slick dots=\"false\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide featuredImg\" ng-repeat=\"i in entry.images\"><img alt=\"{{i.fields.title}}\" ng-src=\"{{i.fields.file.url}}?w=720\"></div></slick></div><div class=\"tiny-wrapper\"><h1><i class=\"material-icons\">lens</i><span ng-bind-html=\"entry.title\"></span></h1><div class=\"contents\" markdown-to-html=\"entry.articleBody\" ng-if=\"entry.articleBody\"></div><div class=\"video\" ng-if=\"entry.video\"><iframe frameborder=\"0\" height=\"400\" ng-src=\"{{getYoutube(entry.video)}}\" width=\"100%\"></iframe></div></div></article><div class=\"clearfix\"></div><div class=\"center-text\" id=\"load-more\"><h4><a class=\"link click\" ng-href=\"{{title | lowercase}}/{{next_article}}\" ng-if=\"next_article\"><i class=\"material-icons\">chevron_right</i><span>Load next article</span></a><a class=\"link click\" ng-href=\"{{title | lowercase}}\" ng-if=\"!next_article\"><i class=\"material-icons\">chevron_right</i><span>Back to {{title | lowercase}}</span></a></h4></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/releases/index.html","<md-header></md-header><div class=\"page grey-bg\" id=\"releases-list\" ng-init=\"addMoreItems()\"><loading></loading><div class=\"wrapper lrg-wrapper\" ng-if=\"!loading\"><article class=\"article-block block columns four\" ng-repeat=\"e in entries\"><div class=\"block-img\"><a ng-href=\"/releases/{{::e.fields.slug}}\"><div class=\"image\" style=\"background-image:url({{::e.fields.mainImage.fields.file.url}})\"></div></a></div><div class=\"block-text\"><h2><i class=\"material-icons\">lens</i><span ng-bind-html=\"::e.fields.artistName.fields.artistName\"></span></h2><h4 ng-bind-html=\"::e.fields.title\"></h4><h4>{{::e.fields.referenceCode}} / {{::e.fields.releaseDate | date: &#39;MMMM&#39;}} / {{::e.fields.releaseDate | date: &#39;yyyy&#39;}}</h4></div></article><div class=\"clearfix\"></div><div class=\"empty\"><div class=\"spacer\"></div><div class=\"center-text\" ng-if=\"!entries.length\">There are no {{page}}</div></div></div><div class=\"center-text\" id=\"load-more\"><h4 class=\"link click\" ng-click=\"addMoreItems()\" ng-if=\"totalItems &gt; fetchedItems\"><i class=\"material-icons\">expand_more</i><span>Load more {{page}}</span></h4><h4 class=\"link\" ng-if=\"totalItems == fetchedItems\"><span>No more {{page}}</span></h4></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/releases/show.html","<md-header></md-header><div class=\"page grey-bg\" id=\"releases-post\"><loading></loading><article class=\"wrapper lrg-wrapper\" ng-if=\"!loading\"><div class=\"columns six\"><div class=\"block-img\"><slick dots=\"true\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide featuredImg\"><img ng-src=\"{{::entry.mainImage.fields.file.url}}?w=620\"></div></slick></div></div><div class=\"columns six\"><div class=\"block-text\" link-away=\"\"><h1><i class=\"material-icons\">lens</i><span ng-bind-html=\"::entry.title\"></span></h1><h4><a ng-bind-html=\"::entry.artistName.fields.artistName\" ng-href=\"/artists/{{entry.artistName.fields.slug}}\"></a></h4><h4>{{::entry.referenceCode}} / {{::entry.releaseDate | date: &#39;MMMM&#39;}} / {{::entry.releaseDate | date: &#39;yyyy&#39;}}</h4><div class=\"contents\" markdown-to-html=\"entry.description\" ng-if=\"entry.description\"></div><a class=\"btn\" ng-href=\"{{::entry.tictailLink}}\" ng-if=\"::entry.tictailLink\" target=\"_blank\">Buy online</a></div></div><div class=\"clearfix\"></div></article></div><md-footer></md-footer>");
$templateCache.put("templates/views/shared/footer.html","<footer role=\"contentInfo\"><div class=\"wrapper lrg-wrapper\"><div class=\"columns eight\"><div class=\"icon_large\" id=\"logo-alt\"></div><ul><li>Ⓒ Woah Dad {{currentDate | date: &#39;yyyy&#39;}}</li><li>All rights reserved</li></ul></div><div class=\"columns two\"><h3>Social</h3><ul><li><a ng-href=\"https://www.facebook.com/Woahdad\" target=\"_blank\">Facebook</a></li><li><a ng-href=\"https://www.instagram.com/woahdad/\" target=\"_blank\">Instagram</a></li><li><a ng-href=\"https://twitter.com/woahdadmusic?lang=en\" target=\"_blank\">Twitter</a></li><li><a ng-href=\"https://soundcloud.com/woahdad\" target=\"_blank\">Soundcloud</a></li><li><a ng-href=\"https://open.spotify.com/user/woahdad\" target=\"_blank\">Spotify</a></li><br><li><a class=\"click\" ng-click=\"showNewsletter()\">Newsletter</a></li></ul></div><div class=\"columns two\"><h3><a ng-href=\"/contact\">Contact</a></h3><ul><li><a ng-href=\"mailto:mom@woahdad.com\">mom@woahdad.com</a></li><br><li><span>Södermannagatan 9</span><br><span>116 23 Stockholm</span><br><span>Sweden</span></li></ul></div><div class=\"clearfix\"></div></div></footer>");
$templateCache.put("templates/views/shared/header.html","<header role=\"banner\"><nav class=\"columns six no-top-margin\" id=\"breadcrumbs\" ng-class=\"{&#39;hidden&#39;: page == &#39;home&#39;, &#39;hiden&#39;: page == &#39;agency&#39;}\"><h4 ng-if=\"page != &#39;news_show&#39; &amp;&amp; page != &#39;artists_show&#39; &amp;&amp; page != &#39;releases_show&#39;\">{{pageTitle}}</h4><h4 ng-if=\"page == &#39;news_show&#39; || page == &#39;artists_show&#39; || page == &#39;releases_show&#39;\"><a ng-href=\"/{{title | lowercase}}\">{{title}}</a> <span>/</span> <a ng-href=\"{{pageUrl}}\">{{pageTitle}}</a></h4></nav><nav class=\"columns six no-top-margin text-right hide-on-mobile\" id=\"header-menu\"><ul><li><h4><a ui-sref=\"about\">About</a></h4></li><li><h4><a ui-sref=\"contact\">Contact</a></h4></li></ul></nav></header><nav class=\"sidebar_{{page}}-page\" id=\"sidebar\"><div class=\"click\" id=\"menu-trigger\" ng-click=\"toggleLeft()\"><i class=\"material-icons\">menu</i></div><a id=\"logo-block\" ui-sref=\"home\"><div class=\"icon_small flipped\" id=\"logo\"></div><h1 class=\"flipped hide-on-mobile\">Woah Dad!</h1></a></nav><md-navigation></md-navigation>");
$templateCache.put("templates/views/shared/loading.html","<div class=\"loading\" ng-if=\"loading\"><div class=\"loading-animation center-text\" title=\"5\"><svg height=\"30px\" id=\"Layer_1\" style=\"enable-background:new 0 0 50 50;\" version=\"1.1\" viewbox=\"0 0 24 30\" width=\"24px\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" y=\"0px\"><rect class=\"shape shape-a\" fill=\"#333\" height=\"5\" width=\"4\" x=\"0\" y=\"13\"></rect><rect class=\"shape shape-b\" fill=\"#333\" height=\"15\" width=\"4\" x=\"10\" y=\"13\"></rect><rect class=\"shape shape-c\" fill=\"#333\" height=\"5\" width=\"4\" x=\"20\" y=\"13\"></rect></svg></div></div>");
$templateCache.put("templates/views/shared/navigation.html","<md-sidenav class=\"md-sidenav-left md-whiteframe-4dp menu_{{page}}-page\" id=\"mobile-menu\" md-component-id=\"left\"><nav class=\"sidebar_{{page}}-page\" id=\"sidebar\"><div class=\"click\" id=\"menu-trigger\" ng-click=\"close()\"><i class=\"material-icons\">close</i></div><a id=\"logo-block\" ui-sref=\"home\"><div class=\"icon_small flipped\" id=\"logo\"></div><h1 class=\"flipped hide-on-mobile\">Woah Dad!</h1></a></nav><nav class=\"center-text\" id=\"main-navigation\"><ul><li><a href=\"/news\" ng-class=\"{&#39;active&#39; : page == &#39;news&#39;}\">News</a></li><li><a href=\"/artists\" ng-class=\"{&#39;active&#39; : page == &#39;artists&#39;}\">Artists</a></li><li><a href=\"/releases\" ng-class=\"{&#39;active&#39; : page == &#39;releases&#39;}\">Releases</a></li><li><a href=\"/agency\" ng-class=\"{&#39;active&#39; : page == &#39;agency&#39;}\">Agency</a></li><li><a href=\"https://woahmom.com/\" target=\"_blank\">Shop</a></li></ul><ul class=\"small-nav show-on-mobile\"><li><a href=\"/about\" ng-class=\"{&#39;active&#39; : page == &#39;about&#39;}\">About</a></li><li><a href=\"/contact\" ng-class=\"{&#39;active&#39; : page == &#39;contact&#39;}\">Contact</a></li></ul></nav></md-sidenav>");
$templateCache.put("templates/views/shared/newsletter-signup.html","<div id=\"newsletter-modal\"><i class=\"material-icons close click\" ng-click=\"closeModal()\">close</i><h2>Signup to our newsletter</h2><div id=\"mc_embed_signup\"><form action=\"https://woahdad.us17.list-manage.com/subscribe/post?u=04d675a1bf12e17d3ad422b6c&amp;amp;id=8de1bf53e6\" class=\"validate\" id=\"mc-embedded-subscribe-form\" method=\"post\" name=\"mc-embedded-subscribe-form\" novalidate=\"\" target=\"_blank\"><div id=\"mc_embed_signup_scroll\"><div class=\"mc-field-group\"><input class=\"required email\" id=\"mce-EMAIL\" name=\"EMAIL\" placeholder=\"Email address\" type=\"email\" value=\"\"></div><input class=\"button\" id=\"mc-embedded-subscribe\" name=\"subscribe\" type=\"submit\" value=\"Subscribe\"><div class=\"clear\" id=\"mce-responses\"><div class=\"response\" id=\"mce-error-response\" style=\"display:none\"></div><div class=\"response\" id=\"mce-success-response\" style=\"display:none\"></div></div><div aria-hidden=\"true\" style=\"position: absolute; left: -5000px;\"><input name=\"b_04d675a1bf12e17d3ad422b6c_8de1bf53e6\" tabindex=\"-1\" type=\"text\" value=\"\"></div></div></form></div></div>");
$templateCache.put("templates/views/shop/index.html","<md-header></md-header><div class=\"page grey-bg\" id=\"merchandise-list\" ng-init=\"addMoreItems()\"><loading></loading><div class=\"wrapper lrg-wrapper\" ng-if=\"!loading\"><section id=\"hero-section\"><article class=\"article-block block columns twelve\"><div class=\"block-img\"><div class=\"image\" style=\"background-image:url({{::header.featuredImage.fields.file.url}})\"></div></div><div class=\"block-text\"><h1 class=\"blink\"><a ng-href=\"\"><i class=\"material-icons\">lens</i><span ng-bind-html=\"::header.mainText\"></span></a></h1><h4 class=\"underline-link\">Shop now</h4></div></article></section><div><article class=\"article-block block columns four\" ng-repeat=\"e in entries\"><div class=\"block-img\"><a ng-href=\"{{::e.fields.tictailLink}}\" target=\"_blank\"><div class=\"image\" style=\"background-image:url({{::e.fields.featuredImage.fields.file.url}})\"></div></a></div><div class=\"block-text\"><h2 class=\"blink\"><a ng-href=\"{{::e.fields.tictailLink}}\" target=\"_blank\"><i class=\"material-icons\">lens</i><span ng-bind-html=\"::e.fields.artistName\"></span></a></h2><h4>{{::e.fields.title}} / {{::e.fields.price}} SEK</h4></div></article><div class=\"clearfix\"></div><div class=\"empty\"><div class=\"spacer\"></div><div class=\"center-text\" ng-if=\"!entries.length\">There are no {{page}}</div></div></div></div><div class=\"center-text\" id=\"load-more\"><h4 class=\"link click\" ng-click=\"addMoreItems()\" ng-if=\"totalItems &gt; fetchedItems\"><i class=\"material-icons\">expand_more</i><span>Load more {{page}}</span></h4><h4 class=\"link\" ng-if=\"totalItems == fetchedItems\"><span>No more {{page}}</span></h4></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/shop/show.html","<md-header></md-header><div class=\"page grey-bg\" id=\"releases-post\"><loading></loading><article class=\"wrapper lrg-wrapper\" ng-if=\"!loading\"><div class=\"columns six\"><div class=\"block-img\"><slick dots=\"true\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide featuredImg\"><img ng-src=\"{{::entry.mainImage.fields.file.url}}?w=620\"></div></slick></div></div><div class=\"columns six\"><div class=\"block-text\" link-away=\"\"><h1><i class=\"material-icons\">lens</i><span ng-bind-html=\"::entry.title\"></span></h1><h4><a ng-bind-html=\"::entry.artistName.fields.artistName\" ng-href=\"/artists/{{entry.artistName.fields.slug}}\"></a></h4><h4>{{::entry.referenceCode}} / {{::entry.releaseDate | date: &#39;MMMM&#39;}} / {{::entry.releaseDate | date: &#39;yyyy&#39;}}</h4><div class=\"contents\" markdown-to-html=\"entry.description\" ng-if=\"entry.description\"></div><a class=\"btn\" ng-href=\"{{::entry.tictailLink}}\" ng-if=\"::entry.tictailLink\" target=\"_blank\">Buy online</a></div></div><div class=\"clearfix\"></div></article></div><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/about.html","<md-header></md-header><div class=\"page\" id=\"about-page\"><section class=\"grey-bg\"><div class=\"text-block center-text\"><h2 markdown-to-html=\"entry.mainText\"></h2></div></section><div class=\"center-text\" id=\"load-more\"><h4><a class=\"link click\" ng-click=\"showNewsletter()\">Signup to our newsletter</a></h4></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/agency.html","<md-header></md-header><div class=\"page\" id=\"agency-page\"><loading></loading><div ng-if=\"!loading\"><section class=\"blue-bg\" id=\"section-one\"><div class=\"text-block center-text\"><div class=\"icon_medium center-block\" id=\"logo\"></div><div class=\"spacer\"></div><h2 markdown-to-html=\"entry.text1\"></h2><a class=\"down-arrow\" du-smooth-scroll=\"\" duration=\"500\" ng-href=\"#section-two\" offset=\"0\"><span class=\"material-icons\">keyboard_arrow_down</span></a></div></section><section id=\"section-two\"><slick dots=\"false\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide\" ng-repeat=\"i in entry.imageGallery\"><img alt=\"{{i.title}}\" ng-src=\"{{i.fields.file.url}}?w=1500\"></div></slick><a class=\"down-arrow hide-on-mobile\" du-smooth-scroll=\"\" duration=\"500\" ng-href=\"#section-three\" offset=\"0\"><span class=\"material-icons\">keyboard_arrow_down</span></a></section><section class=\"red-bg\" id=\"section-three\"><div class=\"text-block center-text\"><div class=\"icon_medium center-block\" id=\"logo\"></div><div class=\"spacer\"></div><h2 markdown-to-html=\"entry.text2\"></h2><a class=\"down-arrow\" du-smooth-scroll=\"\" duration=\"500\" ng-href=\"#section-four\" offset=\"0\"><span class=\"material-icons\">keyboard_arrow_down</span></a></div></section><section id=\"section-four\"><div class=\"text-block center-text\"><h2>Case studies</h2><slick class=\"hide-on-mobile\" dots=\"true\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide\" ng-repeat=\"c in entry.caseStudies\"><div alt=\"{{c.fields.images[0].fields.file.fileName}}\" class=\"image\" style=\"background-image:url({{c.fields.images[0].fields.file.url}}?w=620)\"></div><div class=\"text\"><h2 class=\"blink\"><i class=\"material-icons\">lens</i><span ng-bind-html=\"c.fields.title\"></span></h2><p markdown-to-html=\"c.fields.description\"></p></div></div></slick><article class=\"show-on-mobile\" ng-repeat=\"c in entry.caseStudies\"><div alt=\"{{c.fields.images[0].fields.file.fileName}}\" class=\"image\" style=\"background-image:url({{c.fields.images[0].fields.file.url}}?w=620)\"></div><div class=\"text\"><h2 class=\"blink\"><i class=\"material-icons\">lens</i><span ng-bind-html=\"c.fields.title\"></span></h2><p markdown-to-html=\"c.fields.description\"></p></div></article><div class=\"clearfix\"></div></div></section><section class=\"blue-bg\" id=\"section-five\"><div class=\"text-block center-text\"><div class=\"icon_medium center-block\" id=\"logo\"></div><div class=\"spacer\"></div><h2 markdown-to-html=\"entry.text3\"></h2></div></section></div><div class=\"center-text\" id=\"load-more\"><h4><a class=\"link click\" ng-click=\"showNewsletter()\">Signup to our newsletter</a></h4></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/contact.html","<md-header></md-header><div class=\"page\" id=\"contact-page\"><section class=\"grey-bg\"><div class=\"text-block center-text\"><h2 markdown-to-html=\"entry.mainText\"></h2></div></section><div class=\"center-text\" id=\"load-more\"><h4><a class=\"link click\" ng-click=\"showNewsletter()\">Signup to our newsletter</a></h4></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/home.html","<md-header></md-header><div class=\"page\" id=\"home-page\"><section id=\"section-one\"><video autoplay=\"\" class=\"hide-on-mobile\" id=\"hero-vid\" loop=\"\" muted=\"\" ng-if=\"entry.mainImage &amp;&amp; entry.mainImage.fields.file.contentType === &#39;video/mp4&#39;\" ng-src=\"{{::entry.mainImage.fields.file.url}}\" poster=\"/assets/images/wd-home-image.jpg\" video=\"\"></video><div class=\"show-on-mobile\" id=\"hero-img\" ng-if=\"entry.mainImage &amp;&amp; entry.mainImage.fields.file.contentType === &#39;video/mp4&#39;\" style=\"background-image: url(&#39;/assets/images/wd-home-image.jpg&#39;)\"></div><div id=\"hero-img\" ng-if=\"entry.mainImage &amp;&amp; entry.mainImage.fields.file.contentType !== &#39;video/mp4&#39;\" style=\"background-image: url({{::entry.mainImage.fields.file.url}})\"></div><div id=\"hero-img\" ng-if=\"!entry.mainImage\" style=\"background-image: url(&#39;/assets/images/wd-home-image.jpg&#39;)\"></div><div home-nav=\"\" id=\"hero-block\" ng-class=\"{&#39;loadIn&#39;: loadIn}\"><div class=\"icon_super center-block\" id=\"logo-alt-w\"></div><div id=\"wd-select\"><h4>Take me to</h4><div class=\"split\"><a ng-href=\"/agency\">Agency</a><span>/</span><a ng-href=\"/artists\">Music</a></div></div></div></section><section class=\"grey-bg\" id=\"section-two\"><div class=\"wrapper wrapper-lg\"><h4>Latest news</h4><article class=\"article-block block columns six\" ng-repeat=\"e in entry.news | limitTo: 2\"><div class=\"block-img\"><a ng-href=\"/news/{{::e.fields.slug}}\"><div class=\"image\" style=\"background-image:url({{::e.fields.images[0].fields.file.url}})\"></div></a></div><div class=\"block-text\"><h2 class=\"blink\"><a ng-href=\"/news/{{::e.fields.slug}}\"><i class=\"material-icons\">lens</i><span ng-bind-html=\"::e.fields.title\"></span></a></h2><p ng-bind-html=\"::e.fields.excerpt\"></p><a class=\"underline-link\" ng-href=\"/news/{{::e.fields.slug}}\">Read more</a></div></article><div class=\"clearfix\"></div></div></section><section class=\"light-grey-bg\" id=\"section-three\"><div class=\"wrapper wrapper-lg\"><h4>Latest releases</h4><article class=\"article-block block columns four\" ng-repeat=\"e in entry.releases\"><div class=\"block-img\"><a ng-href=\"/releases/{{::e.fields.slug}}\"><div class=\"image\" style=\"background-image:url({{::e.fields.mainImage.fields.file.url}})\"></div></a></div><div class=\"block-text\"><h2 class=\"blink\"><a ng-href=\"/releases/{{::e.fields.slug}}\"><i class=\"material-icons\">lens</i><span ng-bind-html=\"::e.artistName\"></span></a></h2><h4 ng-bind-html=\"::e.fields.title\"></h4><h4>{{::e.fields.referenceCode}} / {{::e.fields.releaseDate | date: &#39;MMMM&#39;}} / {{::e.fields.releaseDate | date: &#39;yyyy&#39;}}</h4></div></article><div class=\"clearfix\"></div></div></section><section id=\"section-four\" style=\"background-image: url(&#39;/assets/images/wd-shop-background.jpg&#39;)\"><div class=\"image-block\" style=\"background-image: url({{::entry.secondImage.fields.file.url}})\"></div><div class=\"text-block center-text\"><h2><a ng-bind-html=\"::entry.secondImageText\" ng-href=\"{{::entry.secondImageLink}}\"></a></h2><h3><a class=\"show-on-mobile\" ng-href=\"{{::entry.secondImageLink}}\">{SHOP NOW}</a></h3></div></section><div class=\"center-text\" id=\"load-more\"><h4><a class=\"link click\" ng-click=\"showNewsletter()\">Signup to our newsletter</a></h4></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/live.html","<md-header></md-header><div class=\"page\" id=\"live-page\" ng-init=\"addMoreItems()\"><loading></loading><article class=\"wrapper lrg-wrapper block\" link-away=\"\" ng-if=\"!loading\"><div id=\"filters\"><div class=\"columns four no-top-margin first\"><p><span>Filter by:</span><br><span class=\"click link\" ng-click=\"clearFilters()\" ng-if=\"filtersOn\"><span>Clear filters</span><span class=\"material-icons\">close</span></span></p></div><div class=\"columns four no-top-margin\"><form ng-submit=\"searchLive()\"><input autofocus=\"true\" ng-model=\"search.q\" placeholder=\"Search\"></form></div><div class=\"columns four no-top-margin\"><md-menu md-offset=\"0 0\" md-position-mode=\"target-left target\"><div aria-label=\"Open menu\" class=\"link click\" ng-click=\"$mdMenu.open()\"><span ng-if=\"!cityName.length\">Location</span><span ng-bind-html=\"cityName\" ng-if=\"cityName.length\"></span><i class=\"material-icons float-right\">arrow_drop_down</i></div><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"location\" ng-click=\"clearFilters()\">All</md-button></md-menu-item><md-menu-item ng-repeat=\"c in cities | orderBy: c\"><md-button aria-label=\"location\" ng-bind-html=\"c\" ng-click=\"addFilters(c, c, 1)\"></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"clearfix\"></div></div><div id=\"table\"><ul class=\"table-row\" ng-repeat=\"(key, fields) in entries | groupBy: &#39;fields.date&#39; | toArray:true | orderBy:min\"><h2 class=\"blink\"><span class=\"material-icons\">lens</span><span>{{fields[0].fields.date | date: &#39;dd MMMM yyyy&#39;}}</span></h2><ul><li ng-repeat=\"(s, val) in fields\"><span class=\"left\"><div class=\"columns six first\"><div class=\"image hide-on-mobile\" style=\"background-image:url({{val.fields.image.fields.file.url}}?w=320&amp;fm=jpg&amp;fl=progressive)\"></div><div class=\"text\"><a class=\"bold\" ng-bind-html=\"val.fields.title\"></a><span ng-if=\"val.fields.supportArtist\">({{val.fields.supportArtist}})</span></div></div><div class=\"columns four\"><span ng-if=\"val.fields.venue\">{{val.fields.venue}}</span> <span ng-if=\"val.fields.city\">/</span> <span ng-if=\"val.fields.city\">{{val.fields.city}}</span> <span ng-if=\"val.fields.country\">/</span> <span ng-if=\"val.fields.country\">{{val.fields.country}}</span></div></span><span class=\"right\"><div class=\"columns two text-right\"><a class=\"bold\" ng-href=\"{{val.fields.ticketsLink}}\" ng-if=\"val.fields.ticketsLink\" target=\"_blank\">Tickets</a><a ng-href=\"{{val.fields.facebookLink}}\" ng-if=\"val.fields.facebookLink\" target=\"_blank\">Event</a></div><div class=\"clearfix\"></div></span></li></ul></ul><div class=\"center-text\" ng-if=\"!entries.length\"><div class=\"spacer\"></div><h4>Sorry, there are no results for that search</h4></div></div></article><div class=\"center-text\" id=\"load-more\"><h4 class=\"link click\" ng-click=\"addMoreItems()\" ng-if=\"totalItems &gt; fetchedItems\"><i class=\"material-icons\">expand_more</i><span>Load more live shows</span></h4><h4 class=\"link\" ng-if=\"totalItems == fetchedItems\"><span>No more live shows</span></h4></div></div><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/newsletter.html","");}]);